/**
 * Best Times — localStorage utility for Target Blast top 3 times.
 */

const STORAGE_KEY = 'geometry-blast-target-blast-times';
const MAX_TIMES = 3;

/** Load best times from localStorage. Returns sorted array (fastest first), max 3. */
export function loadBestTimes(): number[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed
      .filter((t: unknown) => typeof t === 'number' && t > 0)
      .sort((a: number, b: number) => a - b)
      .slice(0, MAX_TIMES);
  } catch {
    return [];
  }
}

/** Save a new time. Returns updated best times array. */
export function saveBestTime(time: number): number[] {
  const times = loadBestTimes();
  times.push(time);
  times.sort((a, b) => a - b);
  const top = times.slice(0, MAX_TIMES);
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(top));
  } catch {
    // localStorage full or unavailable — silently skip
  }
  return top;
}
